module.exports = __webpack_public_path__ + "img/image.61aed664.png";